import { render, staticRenderFns } from "./YfLadda.vue?vue&type=template&id=53afaff1&"
import script from "./YfLadda.vue?vue&type=script&lang=js&"
export * from "./YfLadda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports